import type { RoleConfig } from '../types.js';

export const strangler: RoleConfig = {
  id: 'strangler',
  faction: 'mafia',
  title: { ru: 'Душитель', uk: 'Душій' },
  latin: 'STRANGLER',
  number: '47',
  accent: '#a04a3a',
  sub: '#3e1810',
  ability: {
    ru: 'Ночью затыкает игроку рот — он не сможет действовать ни этой, ни следующей ночью. Его хватку не остановить — даже если душителя самого заблокируют.',
    uk: 'Уночі затикає гравцеві рота — він не зможе діяти ані цієї, ані наступної ночі. Його хватку не спинити — навіть якщо душія самого заблокують.',
  },
  abilities: [
    // `unblockable` is the strangler's whole identity — the otherwise
    // identical saboteur omits it and CAN be roleblocked.
    { key: 'silence', phase: 'night', cadence: 'every-night', canSelfTarget: false, unblockable: true },
  ],
  reveals: { factions: ['mafia'] },
  victory: { type: 'mafia' },
};
